import * as actions from '../actions/actionTypes';
import { IAuthState } from '../../Interfaces';

const initialState: IAuthState = {
  error: null,
  loading: false,
  verifyEmail: {
    error: null,
    loading: false,
  },
  recoverPassword: {
    error: null,
    loading: false,
  },
};

export default (
  state = initialState,
  action: actions.AuthActionTypes,
): IAuthState => {
  if (action.type === actions.AUTH_CLEAN_UP) {
    return {
      ...state,
      error: null,
      loading: false,
      verifyEmail: {
        ...state.verifyEmail,
        error: null,
        loading: false,
      },
      recoverPassword: {
        ...state.recoverPassword,
        error: null,
        loading: false,
      },
    };
  }

  if (action.type === actions.AUTH_START) {
    return { ...state, loading: true };
  }
  if (action.type === actions.AUTH_END) {
    return { ...state, loading: false };
  }
  if (action.type === actions.AUTH_FAIL) {
    return { ...state, error: action.payload };
  }
  if (action.type === actions.AUTH_SUCCESS) {
    return { ...state, error: false };
  }

  if (action.type === actions.VERIFY_START) {
    return {
      ...state,
      verifyEmail: { ...state.verifyEmail, loading: true },
    };
  }

  if (action.type === actions.VERIFY_SUCCESS) {
    return {
      ...state,
      verifyEmail: {
        ...state.verifyEmail,
        loading: false,
        error: false,
      },
    };
  }

  if (action.type === actions.VERIFY_FAIL) {
    return {
      ...state,
      verifyEmail: {
        ...state.verifyEmail,
        loading: false,
        error: action.payload,
      },
    };
  }

  return state;
};
